// extracted by mini-css-extract-plugin
export default {"cls1":"VeloModalSheetBody-BodyPadding_cls1__F2I1h","cls2":"VeloModalSheetBody-BodyPadding_cls2__Vz9We VeloModalSheetBody-BodyPadding_cls1__F2I1h"};